import { useLazyQuery, useMutation } from "@apollo/client";
import {
  IPrequalificationInfoResponse,
  IPrequalifyInput,
} from "./prequalification.interface";
import { GET_PREQUALIFICATION_INFO } from "./prequalification.query";
import { PREQUALIFY } from "./prequalification.mutation";

export const usePrequalificationInfo = () => {
  const [fetchPrequalificationInfo, { data, loading, error, refetch }] = useLazyQuery<{
    getPrequalificationInfo: IPrequalificationInfoResponse;
  }>(GET_PREQUALIFICATION_INFO, {
    // no-cache (not just network-only): the response carries DOB, address and
    // credit data nothing else reads — keep it out of the InMemoryCache.
    fetchPolicy: "no-cache",
    // Failures render in-flow (error screen with retry), not as a toast.
    context: { suppressGlobalErrorToast: true },
  });

  return {
    fetchPrequalificationInfo,
    prequalificationInfo: data?.getPrequalificationInfo,
    loading,
    error,
    refetch,
  };
};

export const usePrequalify = () => {
  const [prequalify, { data, loading, error, reset }] = useMutation<
    { prequalify: IPrequalificationInfoResponse },
    IPrequalifyInput
  >(PREQUALIFY, {
    // Scratch/network failures are rendered in-flow (error screen with
    // retry), not as the global error toast.
    context: { suppressGlobalErrorToast: true },
    // Same PII payload as the info query — don't write it to the cache.
    fetchPolicy: "no-cache",
  });

  return {
    prequalify,
    prequalificationResult: data?.prequalify,
    loading,
    error,
    reset,
  };
};
